import { Injectable, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError,tap } from 'rxjs/operators';
import { EnglishTestType,
         IecDuration,
         Relationship,
         Country,
         VisaSubClass,
         OHSCProvider,
         YearOfEntry,
         SchoolSubject,
         School,
         Term,
         SchoolDuration,
         SchoolCalendarTermDTO,
         LookupData} from '../models/lookup-data.model';
import { ApiResponse, GenApiResponse } from '../models/api-response.model';
import { SharedService } from './shared.service';
import { HandleHttpError } from './error.handler';
import * as moment from 'moment';


@Injectable()
export class LookupService implements OnInit {

    constructor(private http: HttpClient, private sharedService: SharedService) {
        this.baseURL = this.sharedService.getBaseURL();
    }

    baseURL: string;
    lookupDictionary: any = {};

    ngOnInit() {
    }

    private getLookupData<T>(lookupApiRoute: string): Observable<T[]> {        

        // look for the dictionary in the service instance (singleton)
        if (this.lookupDictionary[lookupApiRoute]) {
            return of(this.lookupDictionary[lookupApiRoute] as T[])
        }

        // look in local storage
        if (localStorage.getItem(lookupApiRoute)) {
            // set item in the dictionary in the service instance
            this.lookupDictionary[lookupApiRoute] = (JSON.parse(localStorage.getItem(lookupApiRoute)) as T[]);
            return of(this.lookupDictionary[lookupApiRoute] as T[]);
        }

        // retrieve from the api
        return this.http.get<ApiResponse>(`${this.baseURL}/${lookupApiRoute}`)
        .pipe(map(apiResponse => {
            if (apiResponse.Errors && apiResponse.Errors.length > 0) {
                return null;
            } else if ( apiResponse.Result) {
                localStorage.setItem(lookupApiRoute, JSON.stringify(apiResponse.Result));
                this.lookupDictionary[lookupApiRoute] = apiResponse.Result as T[];
                return <T[]> apiResponse.Result;
            }
        }));
    }

    // We don't want countries to be cached in browser localStorage, as it might have integrity since 
    getCountries():  Observable<Country[]> {

        // return this.http.get<ApiResponse>(`${this.baseURL}/countries`)
        // .pipe(map(apiResponse => {
        //     if (apiResponse.Errors && apiResponse.Errors.length > 0) {
        //         return null;
        //     } else if ( apiResponse.Result) {
        //         const countries = <Country[]> apiResponse.Result;
        //         return countries.filter(x => !x.IsDeleted);
        //     }
        // }));

        return this.getLookupData<Country>('countries')
                    .pipe(map(countries => countries.filter(x => !x.IsDeleted)));
    }

    getEnglishTestTypes(): Observable<EnglishTestType[]> {
        return this.getLookupData<EnglishTestType>('english-testtype');
    }

    getIecDurations(): Observable<IecDuration[]> {
        return this.getLookupData<IecDuration>('iec-durations');
    }

    getRelationshipTypes(): Observable<Relationship[]> {
        return this.getLookupData<Relationship>('relationships');
    }


    getVisaSubClasses(): Observable<VisaSubClass[]> {
        return this.getLookupData<VisaSubClass>('visa-subclasses');
    }

    getOHSCProviders(): Observable<OHSCProvider[]> {
        return this.getLookupData<OHSCProvider>('oshc-providers');
    }

    getYearsOfEntry(): Observable<YearOfEntry[]> {
        return this.getLookupData<YearOfEntry>('years-of-entry');
    }

    getSchoolSubjects(): Observable<SchoolSubject[]> {
        return this.getLookupData<SchoolSubject>('school-subjects');
    }

    getSchools(): Observable<School[]> {
        return this.getLookupData<School>('schools');
    }

    getDeiApprovedCovid19Vaccines() {
        return this.http.get<{Errors: any, Result: LookupData[]}>(`${this.baseURL}/dei-approved-covid19-vaccines`);
    }

    getTerms(): Observable<Term[]> {
        return this.getLookupData<Term>('terms');
    }

    getDurations(): Observable<IecDuration[]> {
        return this.getLookupData<IecDuration>('durations');
    }


    getSetting(key: string): Observable<any> {
        // return this.getLookupData<any>(`settings/${key}`);

        return this.http.get<ApiResponse>(`${this.baseURL}/settings/${key}`)
            .pipe(map(apiResponse => {
                if (apiResponse.Errors && apiResponse.Errors.length > 0) {
                    return null;
                } else if ( apiResponse.Result) {
                    return apiResponse.Result;
                }
            }));
  }

  getNotificationSettings(userType: number): Observable<any> {
    // return of({Result: null});
    const params = new HttpParams({
        fromObject: {
          userType: userType.toString()
        }
    });

    return this.http.get(`${this.baseURL}/notification-settings`, {params})
      .pipe(
        tap(res => console.log(res)),
        catchError(err => HandleHttpError(err)));
  }


    getAWSAuthSettings(isAgent: boolean): Observable<any> {

        const params = new HttpParams({
            fromObject: {
                isAgent: isAgent.toString()
            }
        });

        //return of({"Errors":[],"Result":{"Region":"ap-southeast-2","UserPoolId":"ap-southeast-2_KjCNCJOJ2","UserPoolWebClientId":"7htrfvmghnmmr6qdrikqh29182","IdentityPoolId":"ap-southeast-2:e718b1c7-f0ef-412d-8012-017c4c1af76e","AuthenticationFlowType":"USER_PASSWORD_AUTH","BucketName":"onlineapp-dev-amplify"}});

        return this.http.get(`${this.baseURL}/aws-settings`, {params})
                .pipe(catchError(err => HandleHttpError(err)));
    }


    getGASettings(): Observable<any> {
      return this.getLookupData<string>('ga-settings')
    }


    getSchoolCalendarTermsBetween(startDate: Date, endDate: Date): Observable<SchoolCalendarTermDTO[]> {
        return this.http.get<GenApiResponse<SchoolCalendarTermDTO[]>>(`${this.baseURL}/school-calendar-terms-between?startDate=${moment(startDate).format('YYYY-MM-DD')}&endDate=${moment(endDate).format('YYYY-MM-DD')}`)
                    .pipe(
                        map(res => res.Result)
                    );
    }

}
